import { Box, Flex, HStack } from "@chakra-ui/layout"
import { Text, Tag, TagLabel } from "@chakra-ui/react"
import { generateBlogCategoryUrl } from "@core/paths";
import { Link } from "@reach/router";
import React from "react"
import { CATEGORY_MODES } from "../categoryModes.enum";

const activeChipBgModeOptions = {
    [CATEGORY_MODES.BASE]: '#EAF4FF',
    [CATEGORY_MODES.ASK_QUESTIONS]: '#E40073'
}

const activeChipColorModeOptions = {
    [CATEGORY_MODES.BASE]: '#222C63',
    [CATEGORY_MODES.ASK_QUESTIONS]: '#FFFFFF'
}

export const ChildrenChips = ({ mainCategory, currentCategory, childrenCategories, mode = CATEGORY_MODES.BASE }) => {
    const isMainCategoryActive = mainCategory.id === currentCategory.id;

    const prepareChipStyleProps = isActive => ({
        color: isActive ? activeChipColorModeOptions[mode] : '#222C63',
        backgroundColor: isActive ? activeChipBgModeOptions[mode] : "#F2F4F5",
    })

    return (
        <Box mb="32px">
            <Flex flexWrap="wrap" justifyContent="flex-start">
                <Tag as={Link} to={generateBlogCategoryUrl(mainCategory.slug)} {...prepareChipStyleProps(isMainCategoryActive)} size="sm" borderRadius="10px" variant="solid" cursor="pointer" px="23px" py="11px" mr="15px" mb="15px">
                    <TagLabel fontWeight={isMainCategoryActive ? "700" : "400"}>Wszystkie</TagLabel>
                </Tag>
                {childrenCategories.map(category => {
                    const isActive = category.id === currentCategory.id;
                    return (
                        <Tag as={Link} to={generateBlogCategoryUrl(category.slug, mainCategory.slug)} {...prepareChipStyleProps(isActive)} size="sm" borderRadius="10px" variant="solid" cursor="pointer" px="23px" py="11px" mr="15px" mb="15px">
                            <TagLabel fontWeight={isActive ? "700" : "400"}>{category.name}</TagLabel>
                        </Tag>
                    )
                })}
            </Flex>
        </Box>
    )
}
